export default (function (siteVars) { return ({
    backgroundColor: siteVars.gray10,
}); });
